import { InviteData } from "../util/sendInvitaion";
import { isProduction } from "fe-common/utils/envGetter";
import { FREE_TEXT_FEATURE_ID, Relations } from "shared";
import { CaseFindingPresentationType } from "fe-common/graphql";

interface CreateCaseResponse {
  caseId: string;
  patient: string;
  pdf: string;
  provider: string;
  status: string;
  summary: string;
  widgetSettings: {
    clinicId: string;
    partnerId: string;
    patientCaseId: string;
  };
}

const AGENT_CASE_API_KEY = "FTTpzynamoEAesCzfW8j3zWHiB1os8Y9QvPmbKZb";

const API_URL = isProduction()
  ? "https://api.kahun.com/cases"
  : "https://api-dev.kahun.com/cases";

export const createClinicPatientCase = async (
  clinicId: string,
  inviteData: InviteData,
  chiefComplaint?: string,
): Promise<CreateCaseResponse> => {
  const patientInfo = inviteData.patient;

  const requestBody = {
    case: {
      format: "kahun",
      demographics: {
        age: patientInfo.age,
        gender: patientInfo.gender,
      },
      features: chiefComplaint
        ? [
            {
              feature: {
                feature: FREE_TEXT_FEATURE_ID,
                qualifiers: [
                  {
                    value: FREE_TEXT_FEATURE_ID,
                    relation: Relations.FREE_TEXT,
                    freeText: chiefComplaint,
                  },
                ],
              },
              group: CaseFindingPresentationType.MainFinding,
            },
          ]
        : [],
    },
    // PII data is being encrypted
    kpiiPatientProperties: {
      visit_date: inviteData.visitDateTime,
      first_name: patientInfo.firstName,
      last_name: patientInfo.lastName,
      phone: patientInfo.phoneNumber,
      email: patientInfo.email,
    },
  };

  const response = await fetch(API_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-api-key": AGENT_CASE_API_KEY,
      "x-kahun-clinic-id": clinicId,
    },
    body: JSON.stringify(requestBody),
  });
  const apiResult = await response.json();
  return apiResult;
};

export const updateClinicPatientCase = async (
  clinicId: string,
  caseId: string,
  status?: string,
  chiefComplaint?: string,
  freeText?: string,
): Promise<CreateCaseResponse> => {
  const features = [];
  if (chiefComplaint) {
    features.push({
      feature: {
        feature: FREE_TEXT_FEATURE_ID,
        qualifiers: [
          {
            value: FREE_TEXT_FEATURE_ID,
            relation: Relations.FREE_TEXT,
            freeText: chiefComplaint,
          },
        ],
      },
      group: CaseFindingPresentationType.MainFinding,
    });
  }
  // if (freeText) {
  //   features.push({
  //     feature: {
  //       feature: FREE_TEXT_FEATURE_ID,
  //       qualifiers: [
  //         {
  //           value: FREE_TEXT_FEATURE_ID,
  //           relation: Relations.FREE_TEXT,
  //           freeText,
  //         },
  //       ],
  //     },
  //     group: CaseFindingPresentationType.ActiveFinding,
  //   });
  // }
  const response = await fetch(API_URL + "/" + caseId, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      "x-api-key": AGENT_CASE_API_KEY,
      "x-kahun-clinic-id": clinicId,
    },
    body: JSON.stringify({
      status,
      case: { caseFormat: "kahun", features },
    }),
  });
  const apiResult = await response.json();
  return apiResult;
};
